import { __extends } from "tslib";
import config from '../config';
import Flow from './Flow';
import ApmService from '../service/Apm';
import encodeHTMLEntities from '../utils/encodeHTMLEntities';
var Summary = /*@__PURE__*/ (function (_super) {
    __extends(Summary, _super);
    function Summary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.init = function () {
            _this.setRoamingStepperItem(config.appointman.flow.SUMMARY);
            if (_this.getState().CURRENT_FLOW === config.appointman.flow.SUMMARY) {
                _this.activate();
            }
            _this.flow = _this.getState().CURRENT_FLOW;
            _this.submitBtnElement = jQuery(_this.getElement()).parent().parent().parent().find('.submit-btn').get(0);
            _this.archiveBtnElement = jQuery(_this.getElement()).parent().parent().parent().find('.archive-btn').get(0);
            _this.registerEventListeners();
            if (_this.getState().apmID) {
                _this.renderSummary();
                jQuery(_this.submitBtnElement)
                    .find('span')
                    .html(config.appointman.msg.SUMMARY_UPDATE_LABEL);
                jQuery(_this.archiveBtnElement)
                    .addClass('shown')
                    .removeClass('disabled')
                    .prop('disabled', false);
            }
        };
        return _this;
    }
    Summary.prototype.onSubmit = function (callback) {
        this.submitEvt = callback;
    };
    Summary.prototype.onCancel = function (callback) {
        this.cancelEvt = callback;
    };
    Summary.prototype.registerEventListeners = function () {
        var _this = this;
        jQuery(this.archiveBtnElement).on('click', function () {
            var apmID = _this.getState().apmID;
            _this.activateLoadingState(Summary.ARCHIVE_LOADING_STATE);
            ApmService
                .cancel(apmID)
                .then(function (res) {
                _this.setState({
                    archived: true
                });
                _this.cancelEvt();
            })
                .catch(function (res) {
                if (!res) {
                    _this.setState({
                        archived: true
                    });
                    _this.cancelEvt();
                    return;
                }
                _this.deactivateLoadingState(Summary.ARCHIVE_LOADING_STATE);
                try {
                    var response = JSON.parse(res.responseText);
                    if (response['Error']) {
                        var errorOutput = '';
                        for (var errorMessage in response['Error']) {
                            errorOutput += response['Error'][errorMessage];
                            errorOutput += '<br>';
                        }
                        jQuery('[data-form-error]').html(errorOutput);
                        jQuery('[data-form-error]').parent().addClass('shown');
                    }
                    else {
                        _this.setState({
                            archived: true
                        });
                        _this.cancelEvt();
                    }
                }
                catch (e) {
                    _this.setState({
                        archived: true
                    });
                    _this.cancelEvt();
                }
            });
        });
        jQuery(this.submitBtnElement).on('click', function () {
            var date = _this.getState().date;
            date = _this.n(date.getDate()) + "." + _this.n(date.getMonth() + 1) + "." + date.getFullYear();
            var appointment = {
                rmsid: _this.getState().rmsID,
                date: date,
                starttime: _this.getState().timeslot,
                email: _this.getState().email,
                phone: _this.getState().phone,
                appointmenttype: _this.getState().apmType,
                appointmenttopic: _this.getState().apmTopic,
                firstname: _this.getState().firstname,
                lastname: _this.getState().lastname
            };
            if (_this.getState().text) {
                appointment.text = _this.getState().text;
            }
            _this.activateLoadingState(Summary.SUBMIT_LOADING_STATE);
            jQuery('[data-form-error]').parent().removeClass('shown');
            if (_this.getState().apmID) {
                ApmService
                    .put(_this.getState().apmID, appointment)
                    .then(function (res) {
                    _this.submitEvt(res);
                })
                    .catch(function (res) {
                    _this.deactivateLoadingState(Summary.SUBMIT_LOADING_STATE);
                    try {
                        var response = JSON.parse(res.responseText);
                        var errorOutput = '';
                        if (response.Error) {
                            for (var errorMessage in response['Error']) {
                                errorOutput += response['Error'][errorMessage];
                                errorOutput += '<br>';
                            }
                        }
                        else {
                            errorOutput = 'Ein Fehler ist aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt.';
                        }
                        jQuery('[data-form-error]').html(errorOutput);
                        jQuery('[data-form-error]').parent().addClass('shown');
                    }
                    catch (e) {
                        jQuery('[data-form-error]').html('Ein Fehler ist aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt.');
                        jQuery('[data-form-error]').parent().addClass('shown');
                    }
                });
                return;
            }
            ApmService
                .post(appointment)
                .then(function (res) {
                _this.submitEvt(res);
            })
                .catch(function (res) {
                _this.deactivateLoadingState(Summary.SUBMIT_LOADING_STATE);
                try {
                    var response = JSON.parse(res.responseText);
                    var errorOutput = '';
                    if (response['Error']) {
                        for (var errorMessage in response['Error']) {
                            errorOutput += response['Error'][errorMessage];
                            errorOutput += '<br>';
                        }
                    }
                    else {
                        errorOutput = 'Ein Fehler ist aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt.';
                    }
                    jQuery('[data-form-error]').html(errorOutput);
                    jQuery('[data-form-error]').parent().addClass('shown');
                }
                catch (e) {
                    jQuery('[data-form-error]').html('Ein Fehler ist aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt.');
                    jQuery('[data-form-error]').parent().addClass('shown');
                }
            });
        });
    };
    Summary.prototype.activateLoadingState = function (loadingState) {
        var _this = this;
        switch (loadingState) {
            case Summary.SUBMIT_LOADING_STATE:
                jQuery(this.archiveBtnElement)
                    .addClass('disabled')
                    .prop('disabled', true);
                jQuery(this.submitBtnElement)
                    .addClass('disabled')
                    .prop('disabled', true)
                    .find('span')
                    .css({
                    opacity: 0,
                    transition: 'all .2s'
                });
                jQuery(this.submitBtnElement)
                    .find('.loading-indicator.submit-loading')
                    .show();
                setTimeout(function () {
                    jQuery(_this.submitBtnElement)
                        .find('.loading-indicator.submit-loading')
                        .addClass('shown');
                }, 2);
                break;
            case Summary.ARCHIVE_LOADING_STATE:
                jQuery(this.submitBtnElement)
                    .addClass('disabled')
                    .prop('disabled', true);
                jQuery(this.archiveBtnElement)
                    .addClass('disabled')
                    .prop('disabled', true)
                    .find('span')
                    .css({
                    opacity: 0,
                    transition: 'all .2s'
                });
                jQuery(this.archiveBtnElement)
                    .find('.loading-indicator.archive-loading')
                    .show();
                setTimeout(function () {
                    jQuery(_this.archiveBtnElement)
                        .find('.loading-indicator.archive-loading')
                        .addClass('shown');
                }, 2);
                break;
            default:
                jQuery(this.archiveBtnElement)
                    .addClass('disabled')
                    .prop('disabled', true);
                jQuery(this.submitBtnElement)
                    .addClass('disabled')
                    .prop('disabled', true)
                    .find('span')
                    .css({
                    opacity: 0,
                    transition: 'all .2s'
                });
                jQuery(this.submitBtnElement)
                    .find('.loading-indicator.submit-loading')
                    .show();
                setTimeout(function () {
                    jQuery(_this.submitBtnElement)
                        .find('.loading-indicator.submit-loading')
                        .addClass('shown');
                }, 2);
        }
    };
    Summary.prototype.deactivateLoadingState = function (loadingState) {
        var _this = this;
        switch (loadingState) {
            case Summary.SUBMIT_LOADING_STATE:
                jQuery(this.archiveBtnElement)
                    .removeClass('disabled')
                    .prop('disabled', false);
                jQuery(this.submitBtnElement)
                    .removeClass('disabled')
                    .prop('disabled', false)
                    .find('span')
                    .css({
                    opacity: 1,
                    transition: 'all .2s'
                });
                jQuery(this.submitBtnElement)
                    .find('.loading-indicator.submit-loading')
                    .removeClass('shown');
                setTimeout(function () {
                    jQuery(_this.submitBtnElement)
                        .find('.loading-indicator.submit-loading')
                        .hide();
                }, 2);
                break;
            case Summary.ARCHIVE_LOADING_STATE:
                jQuery(this.submitBtnElement)
                    .removeClass('disabled')
                    .prop('disabled', false);
                jQuery(this.archiveBtnElement)
                    .removeClass('disabled')
                    .prop('disabled', false)
                    .find('span')
                    .css({
                    opacity: 1,
                    transition: 'all .2s'
                });
                jQuery(this.archiveBtnElement)
                    .find('.loading-indicator.archive-loading')
                    .removeClass('shown');
                setTimeout(function () {
                    jQuery(_this.archiveBtnElement)
                        .find('.loading-indicator.archive-loading')
                        .hide();
                }, 2);
                break;
            default:
                jQuery(this.archiveBtnElement)
                    .removeClass('disabled')
                    .prop('disabled', false);
                jQuery(this.submitBtnElement)
                    .removeClass('disabled')
                    .prop('disabled', false)
                    .find('span')
                    .css({
                    opacity: 1,
                    transition: 'all .2s'
                });
                jQuery(this.submitBtnElement)
                    .find('.loading-indicator.submit-loading')
                    .removeClass('shown');
                setTimeout(function () {
                    jQuery(_this.submitBtnElement)
                        .find('.loading-indicator.submit-loading')
                        .hide();
                }, 2);
        }
    };
    Summary.prototype.onStateChange = function () {
        var state = this.getState();
        if (state.CURRENT_FLOW === config.appointman.flow.SUMMARY) {
            if (this.flow !== state.CURRENT_FLOW) {
                this.flow = state.CURRENT_FLOW;
                this.activate();
                this.renderSummary();
                this.activateSubmitBtn();
            }
        }
        else {
            this.flow = state.CURRENT_FLOW;
            this.deactivateSubmitBtn();
            jQuery('[data-form-error]').parent().removeClass('shown');
        }
    };
    Summary.prototype.activateSubmitBtn = function () {
        jQuery(this.submitBtnElement)
            .prop('disabled', false)
            .removeClass('disabled');
    };
    Summary.prototype.deactivateSubmitBtn = function () {
        jQuery(this.submitBtnElement)
            .prop('disabled', true)
            .addClass('disabled');
    };
    Summary.prototype.renderSummary = function () {
        var state = this.getState();
        // apmType
        var apmType = state.apmType;
        apmType = config.appointman.msg.CHOOSE_TYPE_API[apmType.toString() + "_LABEL"];
        jQuery(this.getElement())
            .find('[data-apmtype]')
            .find('[data-value]')
            .html(apmType);
        // shop
        var shopName = state.shopInfo.name;
        var shopStreet = state.shopInfo.street;
        var shopCity = state.shopInfo.postalcode + " " + state.shopInfo.city;
        jQuery(this.getElement())
            .find('[data-shop] [data-name]')
            .html(encodeHTMLEntities(shopName));
        jQuery(this.getElement())
            .find('[data-shop] [data-street]')
            .html(encodeHTMLEntities(shopStreet));
        jQuery(this.getElement())
            .find('[data-shop] [data-city]')
            .html(encodeHTMLEntities(shopCity));
        // appointment
        var timeslot = state.timeslot;
        var date = state.dateLabel;
        jQuery(this.getElement())
            .find('[data-appointment] [data-timeslot]')
            .html(encodeHTMLEntities(timeslot));
        jQuery(this.getElement())
            .find('[data-appointment] [data-date]')
            .html(encodeHTMLEntities(date));
        // contact
        var contactName = state.firstname + " " + state.lastname;
        var email = state.email;
        var phone = state.phone;
        var apmTopic = state.apmTopic;
        apmTopic = this
            .getState()
            .APPOINTMAN_TYPES[this.getState().apmType]
            .topics[apmTopic];
        var text = state.text;
        jQuery(this.getElement())
            .find('[data-contact] [data-name]')
            .html(encodeHTMLEntities(contactName));
        jQuery(this.getElement())
            .find('[data-contact] [data-email]')
            .html(email);
        jQuery(this.getElement())
            .find('[data-contact] [data-phone]')
            .html(phone);
        jQuery(this.getElement())
            .find('[data-contact] [data-apmTopic]')
            .html(encodeHTMLEntities(apmTopic));
        if (text) {
            if (text.length > 0) {
                jQuery(this.getElement())
                    .find('[data-contact] [data-message]')
                    .html(encodeHTMLEntities(text));
            }
            else {
                jQuery(this.getElement())
                    .find('[data-contact] [data-messageContainer]')
                    .hide();
            }
        }
        else {
            jQuery(this.getElement())
                .find('[data-contact] [data-messageContainer]')
                .hide();
        }
    };
    Summary.prototype.onNextRequest = function () {
    };
    Summary.prototype.n = function (n) {
        return n > 9 ? '' + n : '0' + n;
    };
    Summary.SUBMIT_LOADING_STATE = 0x01;
    Summary.ARCHIVE_LOADING_STATE = 0x02;
    return Summary;
}(Flow));
export default Summary;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/flow/Summary.ts
// module id = null
// module chunks = 